export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_displayImage') || '图片',
    field: 'defaultImage',
    headerAlign: 'center',
    align: 'left',
    width: 70,
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displaySampleName') || '产品名称',
    field: 'displaySampleName',
    minWidth: 280,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySampleName' },
  },
  {
    title: that.$l('table_label_displaySelectionBy') || '选品人',
    field: 'displaySelectionBy',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySelectionBy' },
  },
  {
    title: that.$l('table_label_taskByName') || '任务执行人',
    field: 'taskByName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_selectionRemark') || '任务要求',
    field: 'selectionRemark',
    minWidth: 280,
    align: 'left',
    slots: { default: 'displaySelectionRemark' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_modifyInfo') || '修改人',
    field: 'modifyInfo',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
